export default __webpack_public_path__ + "static/media/azure-acl.e5149609.svg";